import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

//modules
import { CoreModule } from './core/core.module';
import { AngularCoreModule, SharedModule } from '@shared/index';

// Oath module
import { OAuthModule } from 'angular-oauth2-oidc-codeflow-pkce';

//component
import { HeaderInnerComponent, SidebarLeftInnerComponent } from '@core/index';
import { AppComponent } from './app.component';
import { FooterComponent, SidebarMenuComponent } from './index';

// forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// 3rd party libraries boostrap
import { BsDropdownModule, TabsModule } from 'ngx-bootstrap';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { LayoutModule } from 'portalempresa';
import { adminLteConf } from './admin-lte.conf';
import { LoadingPageModule, MaterialBarModule } from 'angular-loading-page';
import { GoogleAnalyticsService } from './core/services/google-analytics.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
	imports: [
		AppRoutingModule,
		AngularCoreModule,
		SharedModule,
		BrowserModule,
		HttpClientModule,
		BsDropdownModule.forRoot(),
		CoreModule.forRoot(),
		MaterialBarModule,
		LayoutModule.forRoot(adminLteConf),
		LoadingPageModule,
		TooltipModule.forRoot(),
		TabsModule.forRoot(),
		OAuthModule.forRoot(),
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
	],
	declarations: [
		AppComponent,
		HeaderInnerComponent,
		SidebarLeftInnerComponent,
		SidebarMenuComponent,
		FooterComponent,
	],
	providers: [GoogleAnalyticsService],
	bootstrap: [AppComponent],
})
export class AppModule {
	constructor(protected googleAnalyticsService: GoogleAnalyticsService) {} // <-- We inject the service here to keep it alive whole time
}
